// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__p6I8t","header":"ClearentDisclaimer_header__1_zCe","inner":"ClearentDisclaimer_inner__1xSun"};